import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import jp from './locales/jp.json';
import ko from './locales/ko.json';

const resources = {
  // 한국어
  ko: {
    translation: ko,
  },
  // 영어
  en: {
    translation: ko,
  },
  // 일본어
  ja: {
    translation: jp,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: window.navigator.language.split('-')[0] ?? 'ko',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
